import { useAuth0 } from '@auth0/auth0-react';
import { User } from '@auth0/auth0-spa-js';

export enum Role {
	ROLE_ANALYST = 'ROLE_ANALYST',
	ROLE_CONTRACTOR = 'ROLE_CONTRACTOR'
}

export function useRoles(): Role[] {
	const { user } = useAuth0();

	const extractRolesAndMapToEnum = (user: User | undefined): Role[] => {
		const userRoles = (user?.['yesenergy/roles'] as string[]) || [];

		return userRoles
			.map(role => Object.values(Role).find(enumRole => enumRole === role))
			.filter((role): role is Role => !!role);
	};

	return extractRolesAndMapToEnum(user);
}
